export var NewBankListMapper = function (data) {
    var list = data.data.map(function (x) {
        return {
            bnkAcNo: x.accountNumber,
            bnkNm: x.bankName,
            brn: x.branch,
            ifscCode: x.ifscCode,
            bankCd: x.bankCode,
            defaultBankRank: x === null || x === void 0 ? void 0 : x.isDefault,
            bankAccType: x === null || x === void 0 ? void 0 : x.bankAccType,
        };
    });
    return {
        data: list,
    };
};
